import { ANALYTICS } from '../../constants/common';
import { trackFormInput, trackFormWorkFlow } from './analyticEvents';

/**
 * @method trackBoostContentInitiate
 * @description this method tracks boost content initiate action
 */
export const trackBoostContentInitiate = () => {
  // Form initiation tracking
  trackFormWorkFlow(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackBoostContentAppliedRecommendationCount
 * @description this method tracks the count of applied recommendations in boost content
 * @param {number} appliedRecommendationCount (applied recommendation count) [number of recommendations applied]
 * @param {string} userEncodedNtid (user encoded ntid) [user encoded ntid for tracking purposes]
 */
export const trackBoostContentAppliedRecommendationCount = (
  appliedRecommendationCount: number,
  userEncodedNtid: string
) => {
  trackFormInput(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.STEP,
    ANALYTICS.APPLIED_RECOMMENDATION_COUNT_QUESTION_NAME,
    appliedRecommendationCount.toString(),
    '1'
  );

  if (userEncodedNtid !== '') {
    trackFormInput(
      ANALYTICS.BOOST_CONTENT_FORM_NAME,
      ANALYTICS.STEP,
      ANALYTICS.USER_ENCODED_NTID_QUESTION_NAME,
      userEncodedNtid,
      '2'
    );
  }
};

/**
 * @method trackBoostContentAppliedByCategory
 * @description tracks applied recommendation counts for each category
 * @param {Record<string, number>} categoryCounts - Object with category names as keys and recommendation counts as values
 * @example trackBoostContentAppliedByCategory({ 'Grammar': 3, 'Spelling': 2, 'Style': 5 })
 */
export const trackBoostContentAppliedByCategory = (
  categoryCounts: Record<string, number>
) => {
  let questionIndex = 1;
  Object.entries(categoryCounts).forEach(([categoryName, count]) => {
    trackFormInput(
      ANALYTICS.BOOST_CONTENT_FORM_NAME,
      ANALYTICS.STEP,
      categoryName,
      count.toString(),
      questionIndex.toString()
    );
    questionIndex++;
  });
};

/**
 * @method trackBoostContentAppliedBySeverity
 * @description tracks applied recommendation counts for each severity level
 * @param {Record<string, number>} severityCounts - Object with severity names as keys and recommendation counts as values
 * @example trackBoostContentAppliedBySeverity({ 'High': 2, 'Medium': 5, 'Low': 3 })
 */
export const trackBoostContentAppliedBySeverity = (
  severityCounts: Record<string, number>
) => {
  let questionIndex = 1;
  Object.entries(severityCounts).forEach(([severityName, count]) => {
    trackFormInput(
      ANALYTICS.BOOST_CONTENT_FORM_NAME,
      ANALYTICS.STEP,
      severityName,
      count.toString(),
      questionIndex.toString()
    );
    questionIndex++;
  });
};

/**
 * @method trackBoostContentAppliedByChannel
 * @description tracks total applied recommendation count for the selected channel
 * @param {string} channelName - The selected channel name
 * @param {number} totalRecommendations - Total number of applied recommendations for this channel
 * @example trackBoostContentAppliedByChannel('email', 10)
 */
export const trackBoostContentAppliedByChannel = (
  channelName: string,
  totalRecommendations: number
) => {
  trackFormInput(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.STEP,
    channelName,
    totalRecommendations.toString(),
    '1'
  );
};

/**
 * @method trackBoostContentComplete
 * @description this method tracks boost content completion
 */
export const trackBoostContentComplete = () => {
  // Form completion tracking
  trackFormWorkFlow(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.FORM_ACTION.COMPLETED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackBoostContentError
 * @description this method tracks boost content errors
 */
export const trackBoostContentError = () => {
  // Form error tracking
  trackFormWorkFlow(
    ANALYTICS.BOOST_CONTENT_FORM_NAME,
    ANALYTICS.FORM_ACTION.ERROR,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};
